import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bold',
  pure: true,
})
export class BoldPipe implements PipeTransform {
  transform(value: string | number): string {
    return `<b>${value}</b>`;
  }
}
